module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAAAXNSR0IArs4c6QAAANlJREFUOE/d0yFLg1EUxvHfYEFw0bBosxr8EAt+AMFiXBDUpIJDhgaDYLFtfgOjwQ+wsLVFg8GuwSBYNq4ceC8M2Tv3GnfrPc//Oc8959ZSSpc4w5rq5wvtWkrp+5+AbDkOSMIjNrFToZknNEKXIbc4xwGu0FwAe8EJhuiFcYaE5hWHGOEUx79ifuICD9jHdWH2NgvJ5s8FYIo7tNBHB1u4x/ZMp3MhcT8piruoYx032JsTsxSSaz8QDxjishX4E7LMsFYR8o6NZcKX1AxiT3ZxVIyyKis+YOcHPJ5ZuNkg9p4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/image/Email.png
// module id = POBL
// module chunks = 2